exports = module.exports = require("../../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".c-video-stream {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n.c-video-stream__title {\n  font-size: 1.5rem;\n  margin-bottom: 1rem;\n}\n\n.c-video-stream__stream {\n  flex: 1 1;\n}\n\n.c-video-stream__iframe {\n  min-width: 20rem;\n  min-height: 20rem;\n  border: 0;\n  width: 100%;\n  height: 100%;\n}", ""]);

